import { render, staticRenderFns } from "./metopeList.vue?vue&type=template&id=19532de5&scoped=true&"
import script from "./metopeList.vue?vue&type=script&lang=js&"
export * from "./metopeList.vue?vue&type=script&lang=js&"
import style0 from "./metopeList.vue?vue&type=style&index=0&id=19532de5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19532de5",
  null
  
)

export default component.exports